import { css } from '@emotion/core';
import { variables } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
export var footer = /*#__PURE__*/css("color:", colour.white, ";font-family:", font.headingFontFamily, ";");
export var showQuickLinks = {
  name: "13o7eu2",
  styles: "display:block;"
};
export var hideQuickLinks = {
  name: "1hyfx7x",
  styles: "display:none;"
};
export var copyright = /*#__PURE__*/css("padding:34px 0 20px;background:", colour.allhomesNavy900, ";text-align:center;svg{height:22px;margin-top:3px;display:inline-block;color:", colour.white, ";text-decoration:none;transition:opacity 0.2s linear;opacity:0.7;&:hover,&:focus,&:active{text-decoration:underline;opacity:0.9;}}");
export var copyrightItemLogo = {
  name: "1hgawz4",
  styles: "vertical-align:top;"
};
export var copyrightItem = /*#__PURE__*/css("display:inline-block;margin:0 20px;vertical-align:middle;font-size:", font.smallFontSize, ";");
export var copyrightLink = /*#__PURE__*/css("display:inline-block;color:", colour.allhomesNavy200, ";text-decoration:none;transition:color 0.2s linear;&:hover,&:focus,&:active{text-decoration:underline;color:", colour.white, ";}");